import { useEffect } from 'react'
import { useStores } from 'stores/utils/hooks/useStores'
import { useUrlParams } from 'stores/utils/hooks/useUrlParams'

/**
 * Registers a MobX reaction that fires a GTM event whenever
 * `common.dataProcessingConsent` changes. Cleans up on unmount.
 */
const useDataProcessingConsentTracking = () => {
  const { traversal } = useStores()
  const urlParams = useUrlParams()

  useEffect(() => {
    if (urlParams.context === 'resume') {
      /* on resume, intentionally force the consent field to false before tracking; do not remove this line of code */
      traversal.handlePathFormFieldChange('common.dataProcessingConsent', false)
    }
  }, [])
}

export default useDataProcessingConsentTracking
